import React, { Component } from 'react';
import { Title } from 'react-admin';
import DashboardMenu from './DashboardMenu';
import LastLoginGraphCard from './graphs/LastLoginGraphCard';
import ConversionRateGraphCard from './graphs/ConversionRateGraphCard';
import RedemptionRateGraphCard from './graphs/RedemptionRateGraphCard';

class DashboardGraphs extends Component {
  render() {
    return (
      <div>
        <Title title="Dashboard Graphs" />

        <DashboardMenu active="graphs" />

        <LastLoginGraphCard />

        <div style={{ display: 'flex' }}>
          <div style={{ paddingLeft: '1rem', flexGrow: 1 }}>
            <RedemptionRateGraphCard />
          </div>
          <div style={{ paddingRight: '1rem', flexGrow: 1 }}>
            <ConversionRateGraphCard />
          </div>
        </div>
      </div>
    );
  }
}

export default DashboardGraphs;



// WEBPACK FOOTER //
// ./src/resources/dashboard/DashboardGraphs.jsx